// extracted by mini-css-extract-plugin
export default {"mCard":"sE-z","image":"tE-z","imageNoBackground":"uE-z","imageHasCategory":"vE-z","fullWidth":"wE-z"};